import { render } from "./OurClinic.vue?vue&type=template&id=3bdef220"
import script from "./OurClinic.vue?vue&type=script&lang=js"
export * from "./OurClinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__